import React from 'react';
import { Button } from '@components/main-components/button/Button';
import { resetFilters } from '../helpers';
import { ExploreMoreSection } from './ExploreMoreSection';

export const ExplorePageNoResults = () => {
  return (
    <div>
      <div className="flex flex-col gap-6 md:px-4">
        <div className="flex flex-col items-center gap-4 py-10">
          <p className="text-title text-center text-title-s font-medium md:text-title-l">
            No results found
          </p>
          <Button
            variant="primary"
            label="Clear filters"
            onClick={() => {
              resetFilters();
            }}
          />
        </div>
        <ExploreMoreSection />
      </div>
    </div>
  );
};
